export default __webpack_public_path__ + "static/media/c-n-v-select.f0d48bc1.svg";